module.exports = __webpack_public_path__ + "img/119.0980a202.svg";